import {getAuditsInformationDataSource} from './audit-information.requests';
import {auditsInformationStore} from './audits-information.store';

export class AuditsInformationQuery {
  store = auditsInformationStore;
  auditsInformationList$ = getAuditsInformationDataSource.data$();
}

export const auditsInformationQuery = new AuditsInformationQuery();
